import React from "react";
import type { KpiActiveUsersComparison, KpiReportResponse } from "../../api/kpi";
import KpiReportView, { isV2Report } from "./KpiReportView";

export const KPI_REPORT_TITLE = "KPI Report";
export const KPI_REPORT_DESCRIPTION =
  "Comprehensive overview of key performance indicators across all time periods and monthly breakdowns";
export const KPI_REPORT_V2_TITLE = "KPI Report V2";
export const KPI_REPORT_V2_DESCRIPTION =
  "Active Users corrected for app users counted twice since March 2026; other figures are identical to the KPI report.";

interface KpiReportContentProps {
  data: KpiReportResponse;
  csvFilePrefix: string;
  activeUsersComparison?: KpiActiveUsersComparison[] | null;
}

// The KPI report as a reader sees it: the title and description follow the report's
// own V2 flag. The live page and the Super Admin preview both render through this,
// so the preview shows exactly what the live page becomes once the flag is on.
const KpiReportContent: React.FC<KpiReportContentProps> = ({
  data,
  csvFilePrefix,
  activeUsersComparison,
}) => {
  const v2 = isV2Report(data);
  return (
    <KpiReportView
      data={data}
      title={v2 ? KPI_REPORT_V2_TITLE : KPI_REPORT_TITLE}
      description={v2 ? KPI_REPORT_V2_DESCRIPTION : KPI_REPORT_DESCRIPTION}
      csvFilePrefix={csvFilePrefix}
      activeUsersComparison={activeUsersComparison ?? undefined}
    />
  );
};

export default KpiReportContent;
